export type FormationProjectMatchesValues = 'YES' | 'NO' | 'NOT_CONCERNED';

export const formationProjectMatches: FormationProjectMatchesValues[] = [
  'YES',
  'NO',
  'NOT_CONCERNED',
];

enum FORMATION_PROJECT_MATCHES {
  YES = 'Oui',
  NO = 'Non',
  NOT_CONCERNED = 'Non concerné',
}
export default FORMATION_PROJECT_MATCHES;
